import { Minus, Plus, X } from "lucide-react";
import { useEffect, useState } from "react";

export interface LightboxImage {
  src: string;
  title: string;
  meta?: string;
}

interface ImageLightboxProps {
  image: LightboxImage;
  onClose: () => void;
}

export function ImageLightbox({ image, onClose }: ImageLightboxProps) {
  const [zoom, setZoom] = useState(1);

  useEffect(() => {
    function handleKeyDown(event: KeyboardEvent) {
      if (event.key === "Escape") onClose();
    }

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [onClose]);

  return (
    <div className="modal-backdrop" role="presentation" onClick={onClose}>
      <section
        className="lightbox-dialog"
        role="dialog"
        aria-modal="true"
        aria-label={`${image.title}放大查看`}
        onClick={(event) => event.stopPropagation()}
      >
        <header className="modal-heading">
          <div>
            <h2>{image.title}</h2>
            {image.meta ? <p>{image.meta}</p> : null}
          </div>
          <button className="icon-button" type="button" onClick={onClose} aria-label="关闭放大查看" title="关闭">
            <X size={18} />
          </button>
        </header>

        <div className="lightbox-stage" onClick={(event) => event.stopPropagation()}>
          <img
            src={image.src}
            alt={image.title}
            style={{ transform: `scale(${zoom})` }}
            draggable={false}
          />
        </div>

        <div className="lightbox-toolbar" onClick={(event) => event.stopPropagation()}>
          <button
            className="icon-button"
            type="button"
            onClick={() => setZoom((value) => Math.max(1, value - 0.25))}
            aria-label="缩小"
            title="缩小"
          >
            <Minus size={18} />
          </button>
          <span>{Math.round(zoom * 100)}%</span>
          <button
            className="icon-button"
            type="button"
            onClick={() => setZoom((value) => Math.min(3, value + 0.25))}
            aria-label="放大"
            title="放大"
          >
            <Plus size={18} />
          </button>
        </div>
      </section>
    </div>
  );
}
